import type { IMedicalCompetence } from "@medoma/models/shifts";
import { medicalCompetenceDictionary } from "@medoma/models/shifts";
import {
  activityRequirementStatusSchema,
  type IActivityRequirementStatus,
} from "@medoma/models/activities";
import CrossIcon from "@medoma/components/icons/CrossIcon";
import { getBorder } from "./chipUtils";
import { useLingui } from "@lingui/react/macro";
import Chip from "@medoma/components/Chip/Chip";
import CustomProperties from "@medoma/components/CustomProperties/CustomProperties";
import styles from "./CompetenceChip.module.scss";

export const CompetenceChip = ({
  competence,
  state,
  content,
  onRemove,
  size,
  variant = "short",
  disabled = false,
}: {
  competence: IMedicalCompetence;
  state: IActivityRequirementStatus;
  content?: string;
  onRemove?: () => void;
  variant?: "short" | "long";
  disabled?: boolean;
} & Pick<Parameters<typeof Chip>[0], "size">) => {
  const { t } = useLingui();
  const label = content ?? t(medicalCompetenceDictionary[competence][variant]);
  const medicalCompetence = t(medicalCompetenceDictionary[competence].long);

  return (
    <CustomProperties className={styles[competence]}>
      <Chip
        onClick={
          state === activityRequirementStatusSchema.enum.assigned &&
          onRemove !== undefined
            ? onRemove
            : undefined
        }
        iconEnd={
          state === activityRequirementStatusSchema.enum.assigned &&
          onRemove !== undefined ? (
            <CrossIcon />
          ) : undefined
        }
        ariaLabel={t`Ta bort ${medicalCompetence}`}
        background="solid"
        border={getBorder(state)}
        size={size}
        disabled={disabled}
      >
        {label}
      </Chip>
    </CustomProperties>
  );
};
